// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__G4ri0","shape-rectangle":"Tab_shape-rectangle__TYw_R","overflow-light":"Tab_overflow-light__rYxyO","overflow-dark":"Tab_overflow-dark__1Vnvr"};